import { useGoogleLogin } from "@react-oauth/google";
import dynamic from "next/dynamic";
import axios from "axios"; 

const SignUpButton = dynamic(() => import("../common/SingUpButton.js"));
const GoogleLogin = ({ onLogin }) => {
    const handleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            const userInfo = await axios
                .get("https://www.googleapis.com/oauth2/v3/userinfo", {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                })
                .then((res) => res.data);
            const googleReponse = { ...tokenResponse, profileObj: userInfo };
            onLogin("Google", googleReponse);
        },
        onError: (errorResponse) => message.error(errorResponse),
    });

    return (
        <SignUpButton
            onClick={() => handleLogin()}
            level="m"
            left={
                <img
                    src="/images/google.png"
                    alt="google"
                    width={20}
                    height={20}
                    layout={"fixed"}
                />
            }
        >
            Continue with Google
        </SignUpButton>
    )
}

export default GoogleLogin;